import { makeNamespacedComponent } from '@/ui/utils';
import { ButtonGroup as ButtonGroup_, ButtonGroupItem } from './ButtonGroup';

const ButtonGroup = makeNamespacedComponent(ButtonGroup_, {
  Item: ButtonGroupItem,
});

export { ButtonGroup };
